/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/22/16.
 */

'use strict';

angular.module('prism-ui.package').controller('SelectDeliveryPartnersModalController', function (
    _,
    $q,
    $timeout,
    $uibModalInstance,
    PackageActionService,
    PartnerPackagesService
) {
    let self = this;
    let parentPartnerChildren = {};

    self.partnerMap = PackageActionService.partnerMap;
    self.availableDeliveryTemplatesForPartners = PackageActionService.availableDeliveryTemplatesForPartners;
    self.redeliveryReasons = PackageActionService.redeliveryReasons;
    self.selectedPartnerMap = {};
    self.selectedRedeliveryReason = null;
    self.selectedPartnerDeliveryItems = null;

    const isChildPartner = (partner) => {
        return partner.parentId && !_.toNumber(partner.numberOfChildren);
    };

    const isParentPartner = (partner) => {
        return !partner.parentId && !!_.toNumber(partner.numberOfChildren);
    };

    var selectPartnersWithNoErrors = function () {
        _.forEach(PackageActionService.partners, function (partner) {
            if(!self.partnerHasErrors(partner)) {
                $timeout(function () {
                    self.gridApi.selection.selectRow(partner);
                });
            }
        });
    };

    var findPartnerDefaultTemplate = function (partner) {
        if (!PackageActionService.partnerMap[partner.id] || !PackageActionService.partnerMap[partner.id].deliveryTemplates) {
            return null;
        }
        var defaultTemplates = PackageActionService.partnerMap[partner.id].deliveryTemplates.filter(function (template) {
            return template.defaultFlag;
        });
        return (defaultTemplates.length === 1 && !self.partnerHasErrors(partner)) ? defaultTemplates[0] : null;
    };

    var selectPartnersFromToggle = function () {
        _.forEach(self.gridApi.selection.getSelectedRows(), function (partner) {
            if (!self.selectedPartnerMap[partner.id] && !isParentPartner(partner)) {
                self.selectedPartnerMap[partner.id] = {
                    template: findPartnerDefaultTemplate(partner)
                };
            }
        });
    };

    var validPartnerSelection = function () {
        var validPartnerSelection = _.keys(self.selectedPartnerMap).length > 0;
        _.forEach(self.selectedPartnerMap, function (selectedPartner) {
            validPartnerSelection = (
                validPartnerSelection &&
                selectedPartner.template !== null &&
                (!selectedPartner.template.template.custom ||
                    selectedPartner.template.partnerDeliveryItemIds.length > 0) &&
                !self.partnerHasErrors(selectedPartner)
            );
        });
        return validPartnerSelection;
    };

    self.columns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'package/common/selectDeliveryPartnersModal/check-mark-tree-template.html',
            headerCellTemplate: `<div class="ui-grid-cell-contents"
                                    col-index="renderIndex"
                                    ng-click="grid.appScope.selectDeliveryPartnersMdlCtrlr.toggleRows($event)">
                                    <input type="checkbox" ng-checked="grid.appScope.selectDeliveryPartnersMdlCtrlr.gridApi.selection.selectAll"/>
                                    <label></label>
                                </div>`
        },
        {
            field: 'name',
            width: '*',
            displayName: 'Partner',
            cellTemplate: 'package/common/selectDeliveryPartnersModal/partner-error-expandable-template.html',
            enableSorting: false,
            enableColumnMenu: false
        }
    ];

    self.gridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        columnDefs: self.columns,
        enableVerticalScrollbar: 2,
        enableHorizontalScrollbar: 0,
        isRowSelectable: function (row) {
            return row.entity.id && self.canSelectPartner(row.entity);
        },
        data: PackageActionService.partners,
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
            self.gridApi.selection.on.rowSelectionChanged(null, self.gridRowSelectionChangedHandler);
            selectPartnersWithNoErrors();
        }
    };

    const togglePartners = (parentRow, selectedChildRow, childPartnerRows) => {
        if (selectedChildRow) {
            let selectedChildRowCount = 0;
            _.forEach(childPartnerRows, (childPartnerRow) => {
                if (childPartnerRow.isSelected) {
                    selectedChildRowCount++;
                }
            });
            parentRow.isSelected = selectedChildRowCount === parentRow.entity.numberOfChildren;
        } else {
            _.forEach(childPartnerRows, (childRow) => {
                childRow.isSelected = parentRow.isSelected;
                if (parentRow.isSelected) {
                    self.selectedPartnerMap[childRow.entity.id] = {template: findPartnerDefaultTemplate(childRow.entity)};
                } else {
                    delete self.selectedPartnerMap[childRow.entity.id];
                }
            });
        }
    };

    const getParentPartnerRow = (selectedPartner) => {
        let parentRow = {};
        _.forEach(self.gridApi.grid.rows, (row) => {
            if (row.entity.id === selectedPartner.parentId) {
                parentRow = row;
            }
        });

        return parentRow;
    };

    const getChildRows = (selectedPartner) => {
        let childRows = [];

        _.forEach(self.gridApi.grid.rows, (row) => {
            if (isParentPartner(selectedPartner)) {
                if (row.entity.parentId === selectedPartner.id) {
                    childRows.push(row);
                }
            } else {
                if (row.entity.parentId === selectedPartner.parentId) {
                    childRows.push(row);
                }
            }
        });
        return childRows;
    };

    self.gridRowSelectionChangedHandler = function (row, event) {
        var partner = row.entity;

        if (!partner.id || self.partnerHasErrors(partner)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        if (row.isSelected && partner.id) {
            if (!_.toNumber(partner.numberOfChildren)) {
                self.selectedPartnerMap[partner.id] = {template: findPartnerDefaultTemplate(partner)};
            }
        } else {
            _.set(self.selectedPartnerMap[partner.id], 'template.partnerDeliveryItemIds', []);
            delete self.selectedPartnerMap[partner.id];
        }

        if (event && (isParentPartner(partner) || isChildPartner(partner))) {
            let parentPartnerRow;
            let childPartnerRow;

            if (isParentPartner(partner)) {
                parentPartnerRow = row;
            } else {
                childPartnerRow = row;
                parentPartnerRow = getParentPartnerRow(partner);
            }

            togglePartners(parentPartnerRow, childPartnerRow, getChildRows(partner));
        }
    };

    self.toggleRows = function (evt) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(evt);
            self.gridApi.selection.selectAll = false;
            self.selectedPartnerMap = {};
        } else {
            _.forEach(self.gridOptions.data, function (selection) {
                if (selection.id && !self.partnerHasErrors(selection)) {
                    self.gridApi.selection.selectRow(selection, evt);
                }
            });
            self.gridApi.selection.selectAll = true;
            selectPartnersFromToggle();
        }
    };

    self.canSelectPartner = function (partner) {
        return self.partnerMap[partner.id].hasValidPackage;
    };

    self.partnerHasErrors = function (partner) {
        return partner &&
               partner.id &&
               self.partnerMap[partner.id] &&
               self.partnerMap[partner.id].partnerPkgErrors &&
               self.partnerMap[partner.id].partnerPkgErrors.length > 0;
    };

    const partnerHasErrorsWarnings = (partner) => {
        return self.partnerMap[partner.id].partnerPkgErrors.length > 0 ||
               self.partnerMap[partner.id].partnerPkgWarnings.length > 0;
    };

    self.showErrorsAndWarningsTriangle = (rowEntity) => {
        return partnerHasErrorsWarnings(rowEntity) && !isChildPartner(rowEntity);
    };

    self.showPartnerCheckmark = (rowEntity) => {
        return !partnerHasErrorsWarnings(rowEntity) && !rowEntity.parentId;
    };

    self.showExpandableRowIndicator = (rowEntity) => {
        return partnerHasErrorsWarnings(rowEntity) && !isChildPartner(rowEntity);
    };

    self.showDeliveryTemplateDropdown = (rowEntity) => {
        return (!self.partnerHasErrors(rowEntity) &&
                !isParentPartner(rowEntity)) ||
                isChildPartner(rowEntity);
    };

    const createDivider = (text=``, color=`black`, fontWeight=`regular`) => {
        return {
            _multiselectDivider: true,
            _multiselectDividerText: text,
            _multiselectDividerColor: color,
            _multiselectDividerFontWeight: fontWeight
        };
    };

    const processPartnerPackageDeliveryItems = (partner, partnerPkgDeliveryItems, partnerPkgId) => {
        let partnerPackageInfo = self.selectedPartnerMap[partner.id].partnerPackageInfoLookup[partnerPkgId];
        let newSelectedIds = _.clone(self.selectedPartnerMap[partner.id].template.partnerDeliveryItemIds);

        let headerDivider = createDivider(`${partnerPackageInfo.package.name}`, 'red', 'bold');
        headerDivider.package = partnerPackageInfo.package;

        let blankDivider = createDivider();
        blankDivider.package = partnerPackageInfo.package;

        _.forEach(partnerPkgDeliveryItems, (deliveryItem) => {
            let msdId = `${partnerPackageInfo.package.id}_${deliveryItem.id}`;
            deliveryItem.partnerPackage = partnerPackageInfo.partnerPackage;
            deliveryItem.package = partnerPackageInfo.package;
            deliveryItem.msdId = msdId;

            // each delivery item must have a unique ID for the
            // selection locking to work in the multiselect
            // dropdown
            deliveryItem.id = msdId;

            if (deliveryItem.requiredForDelivery) {
                newSelectedIds.push(msdId);
            }
        });
        self.selectedPartnerMap[partner.id].template.partnerDeliveryItemIds = newSelectedIds;

        if (partnerPkgDeliveryItems.length === 0) {
            let noItemsDivider = createDivider(`(no configured delivery items)`);
            noItemsDivider.package = partnerPackageInfo.package;
            partnerPkgDeliveryItems.push(noItemsDivider);
        }

        return _.concat(headerDivider, _.sortBy(partnerPkgDeliveryItems, self.deliveryItemDropdownLabelFunction),
            blankDivider);
    };

    self.deliveryTemplateChangeHandler = (partner) => {
        partner.deliveryItems = [];
        if (self.selectedPartnerMap[partner.id].template.template.custom) {
            let deliveryItemPromises = {};
            self.selectedPartnerMap[partner.id].partnerPackageInfoLookup = self.partnerMap[partner.id].partnerPackageInfoLookup;
            _.forEach(_.keys(self.selectedPartnerMap[partner.id].partnerPackageInfoLookup), (partnerPackageId) => {
                deliveryItemPromises[partnerPackageId] = PartnerPackagesService.getApplicableDeliveryItems(partnerPackageId);
            });

            partner.showDeliveryItemsDropdownPacifier = true;

            $q.all(deliveryItemPromises).then((deliveryItems) => {
                let partnerDeliveryItemCollection = [];
                _.forEach(deliveryItems, (partnerPkgDeliveryItems, partnerPkgId) => {
                    partnerDeliveryItemCollection.push(
                        processPartnerPackageDeliveryItems(partner, partnerPkgDeliveryItems, partnerPkgId)
                    );
                });

                partner.deliveryItems = _.chain(partnerDeliveryItemCollection)
                    .sortBy([
                        value => _.first(value).package.content.prefix,
                        value => _.first(value).package.productionNumber
                    ])
                    .flatten()
                    .value();

                partner.deliveryItems.splice(-1, 1);

                // remove package headers if there's only one
                // package...
                let headers = _.filter(partner.deliveryItems, {_multiselectDividerColor: 'red'});
                if (headers.length === 1) {
                    _.remove(partner.deliveryItems, headers[0]);
                }

                partner.showDeliveryItemsDropdownPacifier = false;
            });
        }
    };

    self.deliveryItemDropdownLabelFunction = (deliveryItem) => {
        if (_.isString(deliveryItem)) {
            return 'multiple selections';
        }

        let packagePrefix = _.get(deliveryItem, 'package.content.prefix');
        let packageProductionNumber = _.get(deliveryItem, 'package.productionNumber');
        let entityType = _.get(deliveryItem, 'type');
        let entityId = _.chain(deliveryItem)
            .get('id')
            .split('_')
            .last()
            .value();
        let entityName = _.get(deliveryItem, 'name', `(${entityType} - ID ${entityId})`);

        return `${packagePrefix} ${packageProductionNumber} ${entityName}`;
    };

    self.togglePartnerErrors = function (partner, event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        partner.expanded = !partner.expanded;
        var parentDataIndex = self.gridOptions.data.indexOf(partner);
        if (partner.expanded) {
            var children = self.partnerMap[partner.id].partnerPkgErrors.concat(self.partnerMap[partner.id].partnerPkgWarnings);
            parentPartnerChildren[partner.id] = children;
            self.gridOptions.data.splice.apply(self.gridOptions.data, [parentDataIndex + 1, 0].concat(children));
        } else {
            self.gridOptions.data.splice(parentDataIndex + 1, parentPartnerChildren[partner.id].length);
            parentPartnerChildren[partner.id] = null;
        }
    };

    self.showRedeliverReasonDropdown = function () {
        for (var partnerId in self.selectedPartnerMap) {
            if (self.partnerMap[partnerId].redeliver) {
                return true;
            }
        }
        return false;
    };

    self.onOk = function () {
        $uibModalInstance.close({selectedPartners: self.selectedPartnerMap, redeliveryReason: self.selectedRedeliveryReason});
    };

    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    self.disableOKButton = function () {
        return (self.showRedeliverReasonDropdown() && !self.selectedRedeliveryReason) || !validPartnerSelection();
    };

});
